var map = {
	"./Builiding.jpg": 282,
	"./Card": 616,
	"./Card.css": 951,
	"./Card.js": 616,
	"./Meme.png": 278,
	"./Meme1.png": 458,
	"./Todo.png": 202,
	"./Todo1.png": 956,
	"./center.jpg": 795,
	"./game.jpeg": 772,
	"./game1.jpeg": 820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;